export default {
    path: '/show',
    redirect: '/show/home',
    children: [{
        path: 'home',
        name: 'ShowHome',
        component: () => import("@/views/show/index.vue")
    }]
}